module.exports = __webpack_public_path__ + "static/media/icon_profile.b54d67be.svg";